import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import {memo, useMemo} from 'react';
import {useNavigate} from 'react-router';
import CardInputGroup from '../../../../components/mazraeKit/CardInputGroup';
import {IInputs} from '../../../../services/hookService/getStoreInputs/getStoreInputs';

export interface ICategoryData {
  [key: string]: IInputs[];
}

const CategoryList = memo(
  ({
    categories,
    store,
  }: {
    categories: ICategoryData;
    store?: IShopCardDetail;
  }) => {
    const navigate = useNavigate();

    const categoryEntries = useMemo(
      () => Object.entries(categories),
      [categories],
    );

    const handleViewAll = (InputGroupCode: string) => {
      const link = `/input-search-advertisement-result/${InputGroupCode}/${store?.guid}`;
      navigate(link);
    };

    const handleItemClick = (item: IInputs) => {
      const link = `/input-search-advertisement-result/${item?.input_group?.code}/${store?.guid}/${item?.guid}`;
      navigate(link);
    };

    return (
      <div className="flex flex-col gap-6">
        {categoryEntries.map(([InputGroupCode, items]) => {
          const {icon, title} = items[0]?.input_group ?? {};
          if (!items.length) return null;

          return (
            <div
              key={InputGroupCode}
              className="flex flex-col w-full gap-6"
              role="region"
              aria-label={title}
            >
              <div className="flex items-center justify-between w-full ">
                <div className="flex items-center gap-2 text-gray-700 text-md font-Medium">
                  <SpanIcon className={classNames('text-[20px]', icon)} />
                  <span>{title}</span>
                  <i className={`${icon}  text-xl  text-red-500`} />
                </div>
                <button
                  className="flex items-center gap-2 text-sm transition-colors font-Medium text-farm-shop-500 hover:text-farm-shop-600"
                  onClick={() => handleViewAll(InputGroupCode)}
                  aria-label={`مشاهده همه ${title}`}
                >
                  <span>مشاهده همه</span>
                  <SpanIcon className="icon-nameArrow---Left-2 text-[20px]" />
                </button>
              </div>

              <div className="grid w-full grid-cols-4 ">
                {items.map(item => (
                  <div key={item.guid} className="flex justify-center w-full">
                    <CardInputGroup
                      isActive={false}
                      isBoled={false}
                      title={item.title}
                      image={item.image}
                      guid={item.guid}
                      clickHandler={() => handleItemClick(item)}
                    />
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    );
  },
);

CategoryList.displayName = 'CategoryList';

export {CategoryList};
export default CategoryList;
